/**
 * @generated SignedSource<<21397e4bf6080f0851f5bb15dae42abb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contactActivityHistoryInlineFragment$data = {
  readonly id: string;
  readonly type: string;
  readonly description: string | null;
  readonly createdAt: any | null;
  readonly meta: any | null;
  readonly " $fragmentType": "contactActivityHistoryInlineFragment";
};
export type contactActivityHistoryInlineFragment$key = {
  readonly " $data"?: contactActivityHistoryInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactActivityHistoryInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "contactActivityHistoryInlineFragment"
};

(node as any).hash = "94e5cfffc50189caeed08ccbbd73e493";

export default node;
